export const setUpValue = {
    initialFee: 0,
    distanceFee: 2,
    cartValueFee: 0,
    bulkFee: 0,
    rushHourFee: 1
}